import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TransferPanelService } from './transfer-panel.service';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { OperatorsListComponent } from '../operators-list/operators-list.component';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { StatusCodes } from 'http-status-codes';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-transfer-panel',
  templateUrl: './transfer-panel.component.html',
  styleUrls: ['./transfer-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TransferPanelComponent implements OnInit {
  public selectedItem: string;
  public errorMessage: string;
  public errorMessages: Record<string, string>;
  public isOfflineItemsTransferable;

  @Input()
  private workItemId: string;
  @Input()
  private workItemIds: string[];
  @Input()
  public workItemType: WorkItemTypes;
  @Input()
  public escalateChat: boolean = false;
  @Output()
  public backButtonAction: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public successfulTransferAction: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('operatorList', { static: true })
  operatorList: OperatorsListComponent;

  constructor(private service: TransferPanelService,
              private bcAnalytics: BcAnalytics, private changeDetector: ChangeDetectorRef,
              private _rxEmitter: RxEmitter) {
    this.selectedItem = null;
    this.errorMessage = null;
    this.errorMessages = {
      general: 'bcTransferPanel.assignFailedMessage',
      missingVisitor: 'queueViewTab.missingVisitor'
    };
  }

  ngOnInit(): void {
    this.isOfflineItemsTransferable = this.workItemType === WorkItemTypes.EMAIL;
  }

  public changeSelection(item: string): void {
    if (item === null) {
      this.selectedItem = '';
    } else if (item) {
      this.selectedItem = item;
    }
  }

  public assignWorkItemWithKeyboard(): void {
    this.assignWorkItem();
    this.changeDetector.detectChanges();
  }

  public async assignWorkItem(): Promise<void> {
    let assignPromise;

    if (this.escalateChat) {
      assignPromise = this.service.escalateChats(this._turnSingleWorkItemIntoArray(this.workItemId, this.workItemIds), this.workItemType, this.selectedItem);
    } else {
      if (this.workItemId) {
        this._rxEmitter.send(MessageBusEvents.WorkItemTransferred + `-${this.workItemId}`, this.workItemId);
        assignPromise = this.service.assignWorkItem(this.workItemId, this.workItemType, this.selectedItem);
      } else if (this.workItemIds && this.workItemIds.length) {
        assignPromise = this.service.bulkAssignWorkItems(this.workItemIds, this.workItemType, this.selectedItem);
      } else {
        this._onAssignError();
        return;
      }
    }

    try {
      await assignPromise;
      this.successfulTransferAction.emit();
      this.bcAnalytics.eventTrack('WorkItemAssign', { type: this.workItemType });
    } catch (error) {
      this._onAssignError(error);
    }
  }

  public backButtonClicked(): void {
    this.backButtonAction.emit();
  }

  private _turnSingleWorkItemIntoArray(workItemId: string, workItemIds: string[]): string[] {
    if (workItemId) {
      if (workItemIds instanceof Array) {
        throw new Error('Simultaneous single item and array not allowed');
      }
      return [workItemId];
    }
    if (!workItemIds) {
      throw new Error('No workItems were selected');
    }
    return workItemIds;
  }

  private _onAssignError(error?: HttpErrorResponse): void {
    this.errorMessage = error && error.status === StatusCodes.NOT_FOUND ? this.errorMessages.missingVisitor : this.errorMessages.general;

    if (this.operatorList) {
      this.operatorList.resetOperatorList();
    }
  }
}
